export enum AppActions {
    OPEN_FIND = 'OPEN_FIND',
    FIND_USER = 'FIND_USER',
}